import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, effect, inject, signal } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { DatepickerComponent } from '@shared/components/datepicker/datepicker.component';
import { AutocompleteDirective } from '@shared/directives/autocomplete.directive';
import { DatepickerDirective } from '@shared/directives/datepicker.directive';
import { AutocompleteService } from '@shared/services/autocomplete.service';
import { DatepickerService } from '@shared/services/datepicker.service';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { AutoCompleteComponent } from '../../../../shared/components/auto-complete/auto-complete.component';
import { WINDOW } from '../../search-result.module';

export enum Tabs {
  hotel,
  ecolodge,
}

@Component({
  selector: 'iho-desktop-searchbox',
  templateUrl: './desktop-searchbox.component.html',
  styleUrls: ['./desktop-searchbox.component.scss'],
  providers: [],
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatTabsModule,
    MatFormFieldModule,
    MatButtonToggleModule,
    AutoCompleteComponent,
    AutocompleteDirective,
    DatepickerComponent,
    DatepickerDirective,
  ],
})
export class DesktopSearchboxComponent {
  csrStatus = signal<any>(false);
  autocompleteValidate: boolean = false;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
      @Inject(WINDOW) private window: Window,
  ) {
    effect(
      () => {
        if (this.datepickerService._state() && isPlatformBrowser(this.platformId)) {
          this.csrStatus.set(DatepickerComponent);
        }
      },
      { allowSignalWrites: true }
    );

    this.savedParameters = {
      id: this.autocompleteService._selectedItem().id,
      type: this.autocompleteService._selectedItem().type,
      link: this.autocompleteService._selectedItem().link,
      name: this.autocompleteService._selectedItem().name,
      state: this.autocompleteService._selectedItem()?.state,
      startDate: this.datepickerService._startDate(),
      endDate: this.datepickerService._endDate(),
      isShabAdsCode: this.autocompleteService._selectedItem().isShabAdsCode,
    };

  }

  /*
     - inject
   */
  router = inject(Router);
  autocompleteService = inject(AutocompleteService);
  datepickerService = inject(DatepickerService);
  searchBoxService = inject(SearchBoxService);
  searchDataChanged = false

  /*
     - toggleTab
   */
  selectedTab = Tabs.hotel;
  toggleTab(event: { index: number; tab: unknown }) {
    this.selectedTab = event.index;
    switch (event.index) {
      case Tabs.hotel:
        this.router.navigate(['/home/hotel']);
        break;
      case Tabs.ecolodge:
        this.router.navigate(['/home/ecolodge']);
        break;
    }
  }

  /*
     - start fucking search
   */
  savedParameters: any = {};
  search() {
    this.searchDataChanged = false
    let isValid = true;
    if (this.autocompleteService._selectedItem().id === undefined) {
      this.autocompleteValidate = true;
      isValid = false;
    } else {
      this.autocompleteValidate = false;
    }
    if (isValid) {
      let parameters = {
        id: this.autocompleteService._selectedItem().id,
        type: this.autocompleteService._selectedItem().type,
        link: this.autocompleteService._selectedItem().link,
        name: this.autocompleteService._selectedItem().name,
        state: this.autocompleteService._selectedItem()?.state,
        startDate: this.datepickerService._startDate(),
        endDate: this.datepickerService._endDate(),
        isShabAdsCode: this.autocompleteService._selectedItem().isShabAdsCode,
      };
      Object.entries(parameters).forEach((param) => {
        if (this.savedParameters[param[0]] !== param[1]) {
          this.searchBoxService.triggerSearch(parameters, true, this.autocompleteService.adCode());
          this.searchDataChanged = true
        }
      });
      if (this.searchDataChanged) {
        this.goToTop()
      }

      this.savedParameters = parameters;
    }
  }


  goToTop() {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }, 10);
    }
  }
}
